import { getNightsCount } from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/ChronologicalPickers/utils';
import { ISelectOption } from 'components/shared/BaseFormComponents/Select/types';
import { EAreaEventType, EOrganizedBy, ETripEvent, ITripEvent } from 'detailsv2/structure';

import type { TFormValues } from '../../types';

type TGetSuggestedAreaFormDefaultValues = (params: {
  areaPage?: ISelectOption | null;
  accommodation: Pick<ITripEvent<ETripEvent.Accommodation>, 'datesRange' | 'daysRange'>;
  organizedBy: EOrganizedBy;
}) => Partial<TFormValues>;

export const getSuggestedAreaFormDefaultValues: TGetSuggestedAreaFormDefaultValues = ({
  areaPage,
  accommodation,
  organizedBy,
}) => {
  const range = organizedBy === EOrganizedBy.Day ? accommodation.daysRange : accommodation.datesRange;

  if (!range.start) throw new Error('Invalid form data, start date is required');
  const nightsCount = getNightsCount(range.start, range.end || undefined);

  if (nightsCount >= 3) return { attachedPage: areaPage };
  return { attachedPage: areaPage, areaType: EAreaEventType.CheckInDay };
};
